<div style="float: left; margin-bottom: 2rem; margin-top: 1rem">
  <button (click)="openCreateLeagueDialog()" color="primary"
          mat-raised-button>{{ 'Create League' | translate }}</button>
</div>

<table [dataSource]="leagues" class="mat-elevation-z8" mat-table>
  <ng-container matColumnDef="name">
    <th *matHeaderCellDef mat-header-cell> {{ 'Name' | translate }}</th>
    <td *matCellDef="let league" mat-cell> {{league.name}} </td>
  </ng-container>

  <ng-container matColumnDef="open">
    <th *matHeaderCellDef mat-header-cell> {{ 'Edit' | translate }} </th>
    <td *matCellDef="let league" mat-cell>
      <a (click)="openEditLeagueDialog(league)"
         style="cursor: pointer; color: deepskyblue; font-size: 18px; margin-left: 1rem">
        <i class="fa fa-edit"></i>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="remove">
    <th *matHeaderCellDef mat-header-cell> {{ 'Remove' | translate }} </th>
    <td *matCellDef="let league" mat-cell>
      <a (click)="deleteLeague(league.id)" style="cursor: pointer; color: red; font-size: 18px; margin-left: 1rem;">
        <i class="fa fa-remove"></i>
      </a>
    </td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
</table>

<mat-paginator (page)="onPageChange($event)" [length]="totalItems" [pageSize]="pageSize"></mat-paginator>
